import { cn } from '@utils/cn';
import { type ComponentPropsWithoutRef } from 'react';

const TimeLineItem = ({
  className,
  children,
  ...props
}: ComponentPropsWithoutRef<'li'>) => {
  return (
    <li className={cn('relative last:mb-0', className)} {...props}>
      {children}
    </li>
  );
};

export { TimeLineItem };
